import React from "react";
import Mainlayout from "layouts/main";
import AuthProvider from "contexts/auth";
import AppProvider from "contexts/app"
import { Button, ConfigProvider, Space, App } from 'antd';

//algorithm: theme.darkAlgorithm,
const ThuyTienApp = () => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#1677ff',
                },
            }}
        >
            <App>


                <AppProvider>


                    <AuthProvider>

                        <Mainlayout></Mainlayout>

                    </AuthProvider>
                </AppProvider>
            </App>
        </ConfigProvider>
    );
};

export default ThuyTienApp;
